import { Avatar } from '@mui/material';
import { useAvatar } from '../../context/AvatarContext';
import Spinner from '../Spinner';

export const AvatarGlobal = ({ width = 96, height = 96, size }) => {
  const desktopSize = size?.desktop || { width, height };
  const tabletSize = size?.tablet || desktopSize;
  const mobileSize = size?.mobile || tabletSize;

  return (
    <Avatar
      alt='Avatar'
      src={'/assets/images/avatarSocieties.svg'}
      sx={theme => ({
        width: desktopSize.width,
        height: desktopSize.height,
        [theme.breakpoints.down('md')]: {
          width: tabletSize.width,
          height: tabletSize.height,
        },
        [theme.breakpoints.down('sm')]: {
          width: mobileSize.width,
          height: mobileSize.height,
        },
      })}
    />
  );
};
